import styled from 'styled-components';

export const Row = styled.div`
  padding: 10px 0;
`;
